import React from "react";

const TrainloadContext = React.createContext(
    {
        isPassengerCount: true,
        trainloaddata: {},
        funnel: {},
        updateIsPassengerCount: () => {},
        updateTrainloadData: () => {},
        clearTrainloadData: () => {},
        modifyFunnel: () => {},
        clearFunnel: () => {},
    }
);

export default TrainloadContext;